/* raw layout hash: _default-web-layout-qmfpft:2994bd0fe7f43f157041a506dddcb1df5144afa5a2e53a3aa8535b61b15027b5 */
import React from 'react';
import AppShell from './AppShell.jsx';
import { LAYOUT_MENUS } from './layoutMenus.js';

// Layout "_default-web-layout-qmfpft" — renders its page content through the router outlet.
export default function DefaultWebLayoutQmfpft() {
  return <AppShell layoutName="_default-web-layout-qmfpft" menu={LAYOUT_MENUS['_default-web-layout-qmfpft']} />;
}
